import React, { useContext, useState, useEffect } from "react";
import { Button } from "@fluentui/react-components";
import "../css/Home.css"; // Assuming you have a CSS file for styling
import { Constants } from "../common/constants";
import {
  TeamsFxContext,
  TCTeamsFxContext,
  logger,
} from "@siemensplm/common_utils";
import { useCapabilitiesContext } from "../context/CapabilitiesContext";
import { getSiteCapabilities } from "../common/commonFunctions";
import { capabilityType } from "../types/CommonTypes";
import { Spinner } from "@fluentui/react-components";

const Home: React.FC = () => {
  const { loadCapability, setSiteCapabilitiesList } = useCapabilitiesContext();
  const teamsContext = useContext(TeamsFxContext);
  const tcTeamsContext = useContext(TCTeamsFxContext);
  const [localSiteCapabilitiesList, setLocalSiteCapabilitiesList] = useState<
    capabilityType[]
  >([]);
  const [siteCapabilitiesLoaded, setSiteCapabilitiesLoaded] = useState(false);

  // Fetch site capabilities on component mount
  useEffect(() => {
    // Only call if not already loaded
    if (!siteCapabilitiesLoaded) {
      const fetchCapabilities = async () => {
        const capabilities = await getSiteCapabilities(
          teamsContext,
          tcTeamsContext
        );
        if (!Array.isArray(capabilities) || capabilities.length === 0) {
          return;
        }
        const filteredCapabilities = capabilities?.filter(
          (capability: capabilityType) =>
            capability.capabilityId !== Constants.copilotCapabilityId
        );
        setLocalSiteCapabilitiesList(filteredCapabilities);
        setSiteCapabilitiesList(filteredCapabilities);
        setSiteCapabilitiesLoaded(true);
      };
      fetchCapabilities();
    }
  }, []);

  const selectedCapability = async (
    capabilityName: string,
    capabilityId: string,
    capabilityDomain: string
  ) => {
    logger.logInformation(
      `Home: selectedCapability called with ${capabilityName}, ${capabilityId}, ${capabilityDomain}`
    );
    const isCapabilityLoaded = await loadCapability(
      capabilityName,
      capabilityId,
      capabilityDomain
    );
    if (isCapabilityLoaded) {
      logger.logInformation(
        `Home: selectedCapability succeeded for ${capabilityName}`
      );
      const value = {
        capabilityName: capabilityName,
        capabilityId: capabilityId,
        capabilityDomain: capabilityDomain,
      };
      const capability = JSON.stringify(value);
      localStorage.setItem(Constants.activeCapability, capability);
    }
  };

  const showInstalledApps = () => {
    return (
      <div>
        {localSiteCapabilitiesList.map((capability: capabilityType) => (
          <div key={capability.capabilityId} className="capability-card">
            <img
              className="capability-image-container"
              src={capability.capabilityImage || ""}
              alt={`${capability.capabilityName} logo`}
            />
            <div className="capability-name-container">
              <span className="capability-name">
                {capability.capabilityName}
              </span>
              <span className="capability-domain">
                {capability.capabilityDomain}
              </span>
            </div>
            <Button
              className="capability-button"
              appearance="primary"
              onClick={() =>
                selectedCapability(
                  capability.capabilityName,
                  capability.capabilityId,
                  capability.capabilityDomain
                )
              }
            >
              Open
            </Button>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="home-page">
      {localSiteCapabilitiesList && localSiteCapabilitiesList.length > 0 ? (
        <div className="home-container">
          <span className="main-header">Siemens PLM Apps</span>
          <span className="sub-header">
            Select one of the following installed apps
          </span>
          <div className="capability-cards-container">
            {showInstalledApps()}
          </div>
        </div>
      ) : (
        <div className="loading-spinner-baseapp">
          <Spinner size="large" />
        </div>
      )}
    </div>
  );
};
export default Home;
